import styled, { css } from 'styled-components';

import * as mixin from '@wconcept/wconcept-ui/styles/mixin';
import { setSearchStr } from '@wconcept/wconcept-ui/utils/common';

interface IProps {
  className: string;
}
export const Button = styled.button<IProps>`
  ${mixin.flex({ display: 'inline-flex' })}

  &[disabled],
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;

  svg + span {
    margin-left: ${mixin.pxToVw('4')};
  }

  ${props => {
    if (setSearchStr(props.className, 'mode-test')) {
      return css`
        &.mode-test {
          font-size: 14px;
          line-height: 16px;
          color: #7b7b7b;
          padding: 0px 14px;
          border-radius: 32px;
          min-height: 32px;
          border: 1px solid #ddd;
          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.03);
        }
      `;
    }
    return null;
  }}

  @supports (-webkit-touch-callout: none) {
    margin: 0;
  }

  @media ${({ theme }) => theme.media.sm} {
    svg + span {
      margin-left: 4px;
    }
  }
`;
